module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ef-Gd.1803c30e.png";